module.exports = __webpack_public_path__ + "img/chevron-double-right.10fc3d74.svg";